'use client'

import { useState } from 'react'

const FAQS = [
  {
    q: "How is Ordo different from Birrdi or Golf O'Clock?",
    a: "Three ways: (1) Built-in email marketing — no other booking platform has newsletters included. (2) Design — our interface is leagues ahead. (3) Flat pricing — $199/month for everything, no per-booking fees. We focus on filling bays and keeping members engaged.",
  },
  {
    q: 'What types of facilities is Ordo for?',
    a: 'Indoor golf clubs, simulator lounges, entertainment venues, and multi-bay facilities. 2 bays or 20 — Ordo scales. Works with TrackMan, Uneekor, Full Swing, Foresight, SkyTrak, Golfzon.',
  },
  {
    q: 'Does Ordo control launch monitors or door access?',
    a: "Not yet — launch monitor control and 24/7 access control (RemoteLock, PIN codes) are on our roadmap. If those are must-haves today, we'll be honest: Birrdi has them. But if you want better design, built-in marketing, and easier UX — we're your pick.",
  },
  {
    q: 'How does it prevent double bookings?',
    a: 'Real-time availability with database-level constraints. If two people try to book the same slot, only one succeeds. No more spreadsheet conflicts.',
  },
  {
    q: 'Can I use my own branding?',
    a: "Full white-label. Your subdomain, your logo, your colors. Members think it's custom-built for you.",
  },
  {
    q: "What's the setup process?",
    a: 'Most clubs are live within an hour. Configure bays, set hours, upload branding, invite members. No IT team needed.',
  },
  {
    q: 'How does pricing work?',
    a: '$199/month flat. Everything included — unlimited bays, unlimited members, built-in email marketing, analytics. No setup fees, no per-booking charges, no gotchas.',
  },
  {
    q: 'Does it handle payments?',
    a: 'Yes. Stripe integration for pay-at-booking, membership fees, and billing. Payments go directly to your account.',
  },
]

export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0)

  return (
    <section id="faq" className="py-16 sm:py-24 relative">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-12">
          <div className="inline-block px-3 py-1 rounded-full bg-[#71ED7F]/10 border border-[#71ED7F]/20 text-[#71ED7F] text-xs font-semibold uppercase tracking-wider mb-4">
            FAQ
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-medium tracking-tight text-white">
            Common Questions
          </h2>
        </div>

        {/* FAQ Items */}
        <div className="space-y-3">
          {FAQS.map((faq, i) => (
            <div
              key={i}
              className="bg-[#001716] rounded-xl border border-[#E4FFE7]/[0.08] overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full text-left p-4 sm:p-5 flex items-center justify-between gap-4 hover:bg-white/[0.02] transition-colors"
              >
                <h3 className="font-medium text-sm sm:text-base text-white/90">{faq.q}</h3>
                <span
                  className={`w-6 h-6 rounded-full bg-white/5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${
                    openIndex === i ? 'rotate-180' : ''
                  }`}
                >
                  <svg
                    className="w-3 h-3 text-white/50"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </span>
              </button>
              {openIndex === i && (
                <div className="px-4 sm:px-5 pb-4 sm:pb-5">
                  <p className="text-white/50 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
